<template>
  <div>
    <p class="f-s-16">优惠券<span class="f-l-r" style="color:#73787F">无</span></p>
  </div>
</template>


<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>
</style>